import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useAuth } from '../context/AuthContext';

const links = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Services' },
  { to: '/projects', label: 'Projects' },
  { to: '/videos', label: 'Videos' },
  { to: '/feedback', label: 'Reviews' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <>
      <motion.nav
        initial={{ y: -80 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        style={{
          position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
          padding: '0 clamp(1rem,4vw,2.5rem)',
          background: scrolled ? 'rgba(8,8,8,0.95)' : 'transparent',
          backdropFilter: scrolled ? 'blur(20px)' : 'none',
          borderBottom: scrolled ? '1px solid rgba(201,168,76,0.12)' : '1px solid transparent',
          transition: 'all 0.4s ease',
          height: '70px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}
      >
        {/* Logo */}
        <Link to="/" style={{ textDecoration: 'none' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontFamily: 'Cormorant Garamond,serif', fontSize: '1.4rem', color: '#C9A84C', fontWeight: 700, lineHeight: 1.1 }}>
              NirmalRam
            </span>
            <span style={{ fontSize: '0.62rem', letterSpacing: '3px', textTransform: 'uppercase', color: '#8A8070', marginTop: '2px' }}>
              Construction
            </span>
          </div>
        </Link>

        {/* Desktop Links */}
        <div style={{ display: 'flex', gap: '2rem', alignItems: 'center' }} className="desktop-nav">
          {links.map(l => (
            <Link
              key={l.to}
              to={l.to}
              style={{
                fontSize: '0.8rem', letterSpacing: '1.5px', textTransform: 'uppercase',
                color: pathname === l.to ? '#C9A84C' : '#8A8070',
                textDecoration: 'none', transition: 'color 0.2s',
                borderBottom: pathname === l.to ? '1px solid #C9A84C' : '1px solid transparent',
                paddingBottom: '2px',
              }}
              onMouseEnter={e => e.target.style.color = '#C9A84C'}
              onMouseLeave={e => e.target.style.color = pathname === l.to ? '#C9A84C' : '#8A8070'}
            >
              {l.label}
            </Link>
          ))}
          {user && (
            <Link to="/admin"
              style={{ fontSize: '0.78rem', letterSpacing: '1.5px', color: '#C9A84C', textTransform: 'uppercase', border: '1px solid rgba(201,168,76,0.4)', padding: '0.4rem 1rem', borderRadius: '2px' }}>
              Admin
            </Link>
          )}
          <Link to="/contact" className="btn-gold" style={{ padding: '0.55rem 1.4rem', fontSize: '0.75rem' }}>
            Get Quote
          </Link>
        </div>

        {/* Hamburger */}
        <button
          onClick={() => setOpen(!open)}
          className="mobile-menu-btn"
          style={{ display: 'none', background: 'none', border: 'none', color: '#C9A84C', fontSize: '1.5rem', padding: '0.5rem' }}
        >
          {open ? '✕' : '☰'}
        </button>
      </motion.nav>

      {/* Mobile menu */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            style={{
              position: 'fixed', top: '70px', left: 0, right: 0, zIndex: 999,
              background: 'rgba(8,8,8,0.98)', backdropFilter: 'blur(20px)',
              borderBottom: '1px solid rgba(201,168,76,0.15)',
              padding: '1.5rem',
            }}
          >
            {links.map(l => (
              <Link key={l.to} to={l.to} style={{
                display: 'block', padding: '0.85rem 0', fontSize: '1rem',
                color: pathname === l.to ? '#C9A84C' : '#8A8070',
                borderBottom: '1px solid rgba(201,168,76,0.08)', textDecoration: 'none',
              }}>{l.label}</Link>
            ))}
            <Link to="/contact" className="btn-gold" style={{ display: 'block', textAlign: 'center', marginTop: '1rem' }}>
              Get Free Quote
            </Link>
          </motion.div>
        )}
      </AnimatePresence>

      <style>{`
        @media (max-width: 900px) {
          .desktop-nav { display: none !important; }
          .mobile-menu-btn { display: block !important; }
        }
      `}</style>
    </>
  );
}
